import { FC } from 'react'
import { TextField } from '@mui/material'
import { FormikProps } from 'formik'
import { FormattedMessage } from 'react-intl'
import { StyledCard, StyledCardContent, StyledCardHeader } from './styledComponents'

interface Props {
  formik: FormikProps<any>
  order: any
  permission: (field: string) => boolean
}

const CommentsSection: FC<Props> = ({ formik, order, permission }) => {
  if (!permission('comments')) return null

  return (
    <StyledCard>
      <StyledCardHeader title={<FormattedMessage id="comments" />} />
      <StyledCardContent>
        <TextField
          fullWidth
          id="comments"
          name="comments"
          placeholder="comments"
          rows={3}
          multiline
          type="text"
          onChange={formik.handleChange}
          error={formik.touched.comments && Boolean(formik.errors.comments)}
          defaultValue={order?.comments}
        />
      </StyledCardContent>
    </StyledCard>
  )
}

export default CommentsSection
